






import { Component, Vue } from "vue-property-decorator";
import ev from "./constants/auth/events";
import EventBus from "./event-bus";
import { AUTH_LOGOUT } from "@/store/auth/mutation-types";
import { USER_REQUEST, USER_LOGOUT } from "@/store/user/mutation-types";
import * as locationService from "@/services/location/index";
import * as ownerService from "@/services/owner";

@Component
export default class App extends Vue {
  private async created() {
    EventBus.$on(ev.LOGOUT_EVENT, () => {
      this.$store
        .dispatch(`auth/${AUTH_LOGOUT}`)
        .then(() => this.$store.dispatch(`user/${USER_LOGOUT}`));
         ownerService.clearFilter();
    });

    EventBus.$on(ev.LOGGED_OUT_EVENT, (redirect?: string) => {
      this.$router.push({ name: "login", query: { redirect_to: redirect }});
    });

    EventBus.$on(ev.LOGGED_IN_EVENT, () => {
      this.$store.dispatch(`user/${USER_REQUEST}`).then(() => {
        if (this.$route.query.redirect_to) {
          this.$router.replace({ path: this.$route.query.redirect_to as string })
        } else {
          this.$router.push({ name: "farms-home" });
        }
        
        this.initLocation();
      });
    });
    this.initLocation();
  }

  private async initLocation() {
    locationService.clearLocation();
    locationService.fetchCountries();
    locationService.selectCountry("BRA");
  }
}
